import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import Button from 'rebook/apps/base/components/Button';

import pluralize from 'rebook/apps/utils/text/pluralize';

import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';

import styles from './style.scss';
import ShelveScrollList from './ShelveScrollList';
import NewShelveDialog from '../NewShelveDialog';


class MyShelves extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalWindow: null,
    };
  }

  createNewShelve() {
    this.setState({ modalWindow: true });
  }

  render() {
    const { response, bookId, bookDetail, book, closeModal, removeBookFromTheShelve, gaEventLabel } = this.props;
    const shelvesList = response && response.resp.json.objects;
    const shelvesForAddingCounter = response.resp.json.objects.length - bookDetail.userBookshelfList.length;
    const shelvesForRemoveCounter = bookDetail && bookDetail.userBookshelfList.length;
    const shelvesCounter = removeBookFromTheShelve ? shelvesForRemoveCounter : shelvesForAddingCounter;
    const isShelvesForAdingIsZero = (shelvesForAddingCounter === 0) && (!removeBookFromTheShelve);
    return (
      <React.Fragment>
        {(this.state.modalWindow || isShelvesForAdingIsZero) ?
          <NewShelveDialog {...this.props} gaEventLabel={this.props.gaEventLabel} /> :
          <div className={styles.root}>
            <div className={styles.wrapper}>
              <h2 className={styles.header}>
                {removeBookFromTheShelve ? 'Удаление книги с полки' : 'Добавление книги на полку'}
              </h2>
              <div className={styles.counter}>
                <span>{shelvesCounter} {pluralize(shelvesCounter, 'полка', 'полки', 'полок')}</span>
              </div>
              <div className={styles.scrollListWrapper}>
                <div className={styles.scrollList}>
                  {shelvesList.map((shelve) => {
                    return (
                      <ShelveScrollList shelve={shelve} text={shelve.name} key={shelve.id} bookId={bookId}
                        bookDetail={bookDetail} book={book} closeModal={closeModal}
                        removeBookFromTheShelve={removeBookFromTheShelve} gaEventLabel={gaEventLabel} />
                    );
                  })}
                </div>
              </div>
              {removeBookFromTheShelve ? null :
                <Button
                  handleClick={this.createNewShelve.bind(this)}>
                  Создать полку
                </Button>
              }

            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}

MyShelves.propTypes = {
  response: PropTypes.object,
  bookId: PropTypes.number.isRequired,
  bookDetail: PropTypes.object.isRequired,
  book: PropTypes.object.isRequired,
  closeModal: PropTypes.func,
  removeBookFromTheShelve: PropTypes.bool,
  gaEventLabel: PropTypes.string,

};

function mapStateToProps(state) {
  return {
    bookDetail: state.bookDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyShelves);

